import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpErrorResponse } from '@angular/common/http';
import { Observable, of, throwError } from 'rxjs';
import { map, catchError } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import { IEmailTemplateModel } from '../Shared/model/EmailTemplateModel';

@Injectable({
  providedIn: 'root',
})

export class EmailTemplateService {
  private baseURL: string;
  constructor(private http: HttpClient) {
    this.baseURL = environment.apiBaseUrl;
  }

  private options = { headers: new HttpHeaders({ 'Content-Type': 'application/json' }) };

  GetAllEmailTemplateList(): Observable<any> {
    return this.http.get<any>(
      `${this.baseURL}/EmailTemplate/GetAllEmailTemplateList`,
      { observe: 'response' })
      .pipe(
        map(res => {

          const result = res.body as any;
          return result;
        }),
        catchError(this.handleError)
      );
  }

  UpdateOrSaveEmailTemplate(EmailTemplate: IEmailTemplateModel): Observable<any> {

    const options = { headers: new HttpHeaders({ 'Content-Type': 'application/json' }) };
    const url = `${this.baseURL}/EmailTemplate/UpdateOrSaveEmailTemplate`;
    return this.http.post<any>(url, EmailTemplate, options)
      .pipe(
        catchError(this.handleError)
      );
  }

  GetEmailTemplateById(Id: number): Observable<any> {
    return this.http.get<any>(
      `${this.baseURL}/EmailTemplate/GetEmailTemplateById?Id=${Id}`,

      { observe: 'response' })
      .pipe(
        map(res => {
          const result = res as any;
          return result;
        }),
        catchError(this.handleError)
      );
  }

  DeleteEmailTemplate(Id: number): Observable<any> {
    return this.http.get<any>(
      `${this.baseURL}/EmailTemplate/DeleteEmailTemplate?Id=${Id}`,

      { observe: 'response' })
      .pipe(
        map(res => {
          const result = res as any;
          return result;
        }),
        catchError(this.handleError)
      );
  }

  GetAllBaseTemplateTypeList(): Observable<any> {
    return this.http.get<any>(
      `${this.baseURL}/EmailTemplate/GetAllBaseTemplateTypeList`,
      { observe: 'response' })
      .pipe(
        map(res => {

          const result = res.body as any;
          return result;
        }),
        catchError(this.handleError)
      );
  }

  GetAllMergeFieldList(): Observable<any> {
    return this.http.get<any>(
      `${this.baseURL}/EmailTemplate/GetAllMergeFieldList`,
      { observe: 'response' })
      .pipe(
        map(res => {

          const result = res.body as any;
          return result;
        }),
        catchError(this.handleError)
      );
  }

  GetEmailSettings(): Observable<any> {
    return this.http.get<any>(
      `${this.baseURL}/EmailSettings/GetEmailSettings`,
      { observe: 'response' }
    ).pipe(
      map(res => {
        return res.body as any;
      }),
      catchError(this.handleError)
    );
  }

  SaveEmailSettings(model: any): Observable<any> {
    const headers = new HttpHeaders({ 'Content-Type': 'application/json' });
    return this.http.post<any>(
      `${this.baseURL}/EmailSettings/SaveEmailSettings`,
      model,
      { headers }
    ).pipe(
      map(res => {
        return res as any;
      }),
      catchError(this.handleError)
    );
  }

  private handleError(error: HttpErrorResponse) {
    console.error('server error:', error);
    if (error.error instanceof Error) {
      const errMessage = error.error.message;
      // this.appinsights.logEvent(errMessage);
      return throwError(errMessage);
    }
    return throwError(error || 'Node.js server error');
  }

}
